// extracted by mini-css-extract-plugin
module.exports = {"container":"Reviews_container__16RLP","link":"Reviews_link__2ASkZ"};